module.exports = __webpack_public_path__ + "img/resources6.dd731540.jpg";